import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22H22V12ZM20 12V20H12C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM7.84726 11.024C7.37933 11.024 7 10.5709 7 10.012C7 9.45308 7.37933 9 7.84726 9H16.3199C16.7878 9 17.1671 9.45308 17.1671 10.012C17.1671 10.5709 16.7878 11.024 16.3199 11.024H7.84726ZM7.01046 14.0756C7.01046 14.6345 7.37462 15.0876 7.82383 15.0876H14.3308C14.78 15.0876 15.1442 14.6345 15.1442 14.0756C15.1442 13.5167 14.78 13.0636 14.3308 13.0636H7.82383C7.37462 13.0636 7.01046 13.5167 7.01046 14.0756Z"
      fill={fill}
    />
  </g>
);

export default Icon;
